module.exports = __webpack_public_path__ + "static/img/12.c28acef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/12.png
// module id = 5nW6
// module chunks = 0